import financeiroApi from './financeiroApi';

const PATH = '/api/v1/backend/pessoa';

// Axios.create({url:})

export default {
  buscarPessoaFisica: (search) =>
    financeiroApi.get(`${PATH}/pesquisa/pessoa-fisica`, {
      params: {
        q: search,
      },
    }),
  buscarPessoaJuridica: (search) =>
    financeiroApi.get(`${PATH}/pesquisa/pessoa-juridica`, {
      params: {
        q: search,
      },
    }),
  buscarPessoaCompleta: (pessoaId) => financeiroApi.get(`${PATH}/${pessoaId}`),
};
